import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular/lazy';
import { ToastController } from '@ionic/angular/lazy';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(
    private alertController: AlertController,
    public toastController: ToastController
  ) {}

  async presentAlert(
    header: string,
    message: string,
    handler: (() => void) | null = null
  ): Promise<void> {
    const buttonText = 'OK';
    const alert = await this.alertController.create({
      header: 'prim says:',
      cssClass: 'custom-class',
      subHeader: header,
      message: message,
      buttons: [
        {
          text: buttonText,
          handler: handler ?? undefined,
        },
      ],
    });

    await alert.present();
  }

  async presentToast(
    message: string,
    icon?: string,
    color?: string,
    time = 2000
  ): Promise<void> {
    const toast = await this.toastController.create({
      message: message,
      icon: icon,
      color: color,
      duration: time,
      position: 'top',
    });
    toast.present();
  }
}
